export const POPUP_WIDTH = 370;
export const POPUP_HEIGHT_PERCENT = 0.8;

export const AI_AGENT_POPUP_WIDTH = 500;
